export const addUserModalName = 'add-user';

export const fieldDisplayNames: { [key in string]: string } = {
  login: 'Логин',
  password: 'Пароль',
  confirmPassword: 'Подтверждение пароля'
};
